import React from "react";
import type { Project } from "../../../state/workspaces/types";
import { Localized } from "../../../strings";
import { hiconToHoyluUiIconsCentered } from "../../../utils/icon.map";
import Styles from "./ProjectLabel.module.css";

const ProjectLabel = ({
  project,
  onClick,
}: {
  project: Project;
  onClick: (e: React.MouseEvent, project: Project) => void;
}): React.JSX.Element => {
  const isProjectInactive = project.status === "Inactive";
  const projectName = isProjectInactive
    ? `${Localized.string("FILTER_BY_NAME.INACTIVE")}: ${project.name}`
    : project.name;
  const tooltip = isProjectInactive
    ? Localized.string("WORKSPACE_CARD.INACTIVE_PROJECT_LABEL")
    : project.name;

  return (
    <div
      className={Styles.projectLabel}
      onClick={(e) => onClick(e, project)}
      style={{ borderColor: `${project.color}` }}
      title={tooltip}
    >
      <div
        className={`${hiconToHoyluUiIconsCentered(project.icon)} ${
          Styles.projectIcon
        }`}
        style={{ color: `${project.color}` }}
      />
      <div className={Styles.projectName}>{projectName}</div>
    </div>
  );
};

export default ProjectLabel;
